import {
  Cpu, Code2, BarChart3, Palette, PenTool, Target,
  TrendingUp, Users, ShieldCheck, Clock, Heart,
} from "lucide-react";

export const SERVICE_NODES = [
  {
    slug: "ai-automation",
    icon: Cpu,
    label: { de: "KI & Automatisierung", en: "AI & Automation" },
    bullets: {
      de: ["Workflow-Automatisierung", "AI-Agenten & Chatbots", "CRM & Lead-Automatisierung", "Prozess-Optimierung"],
      en: ["Workflow Automation", "AI Agents & Chatbots", "CRM & Lead Automation", "Process Optimization"],
    },
    pos: { top: 8, left: 50 }, // top centre
  },
  {
    slug: "web-development",
    icon: Code2,
    label: { de: "Webentwicklung", en: "Web Development" },
    bullets: {
      de: ["Business-Websites", "E-Commerce-Lösungen", "Web-Anwendungen", "Performance & SEO"],
      en: ["Business Websites", "E-Commerce Solutions", "Custom Web Apps", "Performance & SEO"],
    },
    pos: { top: 30, left: 16 },
  },
  {
    slug: "digital-marketing",
    icon: BarChart3,
    label: { de: "Digital Marketing", en: "Digital Marketing" },
    bullets: {
      de: ["SEO & lokales SEO", "Google Ads & Meta Ads", "Content Marketing", "Analytics & Reporting"],
      en: ["SEO & Local SEO", "Google Ads & Meta Ads", "Content Marketing", "Analytics & Reporting"],
    },
    pos: { top: 30, left: 84 },
  },
  {
    slug: "content-branding",
    icon: PenTool,
    label: { de: "Content & Branding", en: "Content & Branding" },
    bullets: {
      de: ["Content-Strategie", "Copywriting", "Social-Media-Content", "Brand Messaging"],
      en: ["Content Strategy", "Copywriting", "Social Media Content", "Brand Messaging"],
    },
    pos: { top: 64, left: 16 },
  },
  {
    slug: "brand-design",
    icon: Palette,
    label: { de: "Brand Design", en: "Brand Design" },
    bullets: {
      de: ["Logo & Identity-Design", "Brand-Guidelines", "Visuelle Systeme", "Marketing-Materialien"],
      en: ["Logo & Identity Design", "Brand Guidelines", "Visual Identity", "Marketing Materials"],
    },
    pos: { top: 64, left: 84 },
  },
  {
    slug: "strategy-consulting",
    icon: Target,
    label: { de: "Strategie & Consulting", en: "Strategy & Consulting" },
    bullets: {
      de: ["Business-Strategie", "Digitale Transformation", "Growth Planning", "Prozess-Verbesserung"],
      en: ["Business Strategy", "Digital Transformation", "Growth Planning", "Process Improvement"],
    },
    pos: { top: 88, left: 50 },
  },
];

export const BENEFITS = [
  {
    icon: Users,
    title: { de: "Ein vertrauensvoller Partner", en: "One Trusted Partner" },
    desc: { de: "Alle Leistungen. Ein Team. Ein Ziel — dein Wachstum.", en: "All services. One team. One goal — your growth." },
  },
  {
    icon: ShieldCheck,
    title: { de: "Integriert & vernetzt", en: "Integrated & Connected" },
    desc: { de: "Jede Leistung greift in die nächste für maximale Wirkung.", en: "Every service works together for maximum impact." },
  },
  {
    icon: TrendingUp,
    title: { de: "Ergebnisorientiert", en: "Results Driven" },
    desc: { de: "Datengetriebene Strategien mit messbaren Ergebnissen.", en: "Data-led strategies that deliver measurable results." },
  },
  {
    icon: Clock,
    title: { de: "Zukunftsbereit", en: "Future Ready" },
    desc: { de: "Innovative Lösungen, die mit dir skalieren.", en: "Innovative solutions built to scale your business." },
  },
  {
    icon: Heart,
    title: { de: "Kundenerfolg zuerst", en: "Client Success First" },
    desc: { de: "Dein Erfolg ist unsere Mission.", en: "Your success is our mission." },
  },
];
